import { Flex, Text, Box, HStack, VStack, Image } from '@skin-seoul/design-system';
import { CLASSNAME, type Review } from '@skin-seoul/service';
import type { Product } from '@skin-seoul/service';
import LucideIcon from '@/components/ui/LucideIcon';
import NextImage from 'next/image';
import { getTestimonialDisplayImage } from '../utils/imageUtils';
import { format } from 'date-fns';
import { SafeLink } from '@/components/ui/SafeLink';
import { extractPathname } from '@skin-seoul/utils';
interface TestimonialCardProps {
  review: Review;
  product?: Product;
}
const TestimonialCard = ({
  review,
  product
}: TestimonialCardProps) => {
  const displayImage = getTestimonialDisplayImage(review, product);
  return <Flex flexDirection="column" width="100%" borderRadius="8px" padding={4} gap={4} backgroundColor="neutral.50" height="100%" data-sentry-element="Flex" data-sentry-component="TestimonialCard" data-sentry-source-file="TestimonialCard.tsx">
      <Box width="100%" height="272px" minHeight="272px" borderRadius="8px" overflow="hidden" position="relative" backgroundColor="generic.0" data-sentry-element="Box" data-sentry-source-file="TestimonialCard.tsx">
        {displayImage ? <NextImage src={displayImage} alt={review.title || 'Product'} style={{
        objectFit: 'cover'
      }} fill /> : <Flex width="100%" height="100%" justifyContent="center" alignItems="center">
            <LucideIcon name="Image" boxSize={8} color="neutral.400" />
          </Flex>}
      </Box>

      <HStack gap={4} alignItems="center" width="100%" backgroundColor="generic.0" paddingX={4} paddingY={2} borderRadius="8px" justifyContent="space-between" data-sentry-element="HStack" data-sentry-source-file="TestimonialCard.tsx">
        <HStack gap={1} alignItems="center" data-sentry-element="HStack" data-sentry-source-file="TestimonialCard.tsx">
          <Text color="primary.400" textStyle="heading.h6" fontWeight="semibold" data-sentry-element="Text" data-sentry-source-file="TestimonialCard.tsx">
            {review.rating}
          </Text>
          <LucideIcon name="Star" boxSize={5} fill="warning.500" color="warning.500" data-sentry-element="LucideIcon" data-sentry-source-file="TestimonialCard.tsx" />
        </HStack>
        <Text color="neutral.400" textStyle="label.small" fontWeight="regular" data-sentry-element="Text" data-sentry-source-file="TestimonialCard.tsx">
          {format(review.modifiedAt, 'dd/MM/yyyy')}
        </Text>
      </HStack>
      <VStack gap={4} width="100%" alignItems="flex-start" data-sentry-element="VStack" data-sentry-source-file="TestimonialCard.tsx">
        <VStack gap={2} width="100%" alignItems="flex-start" data-sentry-element="VStack" data-sentry-source-file="TestimonialCard.tsx">
          <Text color="neutral.800" textStyle="heading.h5" fontWeight="semibold" lineClamp={1} data-sentry-element="Text" data-sentry-source-file="TestimonialCard.tsx">
            {review.title}
          </Text>
          <HStack gap={1} alignItems="flex-start" h="48px" position="relative" data-sentry-element="HStack" data-sentry-source-file="TestimonialCard.tsx">
            <Text as="span" color="neutral.500" lineClamp={2} textStyle="paragraph.medium" fontWeight="regular" wordBreak="break-word" data-sentry-element="Text" data-sentry-source-file="TestimonialCard.tsx">
              {review.body}
            </Text>
          </HStack>
        </VStack>
        <HStack gap={1} alignItems="center" data-sentry-element="HStack" data-sentry-source-file="TestimonialCard.tsx">
          <Text color="neutral.500" textStyle="label.small" fontWeight="regular" data-sentry-element="Text" data-sentry-source-file="TestimonialCard.tsx">
            Review by
          </Text>
          <Text color="neutral.800" lineClamp={1} textStyle="label.small" fontWeight="regular" data-sentry-element="Text" data-sentry-source-file="TestimonialCard.tsx">
            {review.name}
          </Text>
        </HStack>
      </VStack>
      <HStack gap={2} padding={2} bg="generic.0" borderRadius="8px" alignItems="center" width="100%" data-sentry-element="HStack" data-sentry-source-file="TestimonialCard.tsx">
        <Image asChild borderRadius="8px" bg="neutral.50" alt={`${product?.name} product image`} data-sentry-element="Image" data-sentry-source-file="TestimonialCard.tsx">
          <NextImage src={product?.productImageUrls[0] || ''} alt={`${product?.name} product image`} width={60} height={60} style={{
          mixBlendMode: 'darken'
        }} data-sentry-element="NextImage" data-sentry-source-file="TestimonialCard.tsx" />
        </Image>
        <VStack gap={2} alignItems="flex-start" justifyContent="center" data-sentry-element="VStack" data-sentry-source-file="TestimonialCard.tsx">
          <Text color="neutral.700" textStyle="label.medium" fontWeight="semibold" className={CLASSNAME.NOT_TRANSLATE} data-sentry-element="Text" data-sentry-source-file="TestimonialCard.tsx">
            {product?.brand}
          </Text>
          <SafeLink href={extractPathname(product?.productLink || '#')} textDecoration="underline" color="neutral.400" textStyle="paragraph.small" fontWeight="regular" lineClamp={2} className={CLASSNAME.NOT_TRANSLATE} data-sentry-element="SafeLink" data-sentry-source-file="TestimonialCard.tsx">
            {product?.name}
          </SafeLink>
        </VStack>
      </HStack>
    </Flex>;
};
export default TestimonialCard;